module.exports = __webpack_public_path__ + "img/foot_p1.ebed3189.png";